import { render, staticRenderFns } from "./AppRiattivaUtente.vue?vue&type=template&id=e3b96824&"
import script from "./AppRiattivaUtente.vue?vue&type=script&lang=js&"
export * from "./AppRiattivaUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports